import React from 'react';
import { Card, CardBody, CardHeader, Button } from 'reactstrap';
import { Link } from 'react-router-dom';

const QuickActions = () => {
    const quickActions = [
        {
            title: 'Process Document',
            description: 'Upload and process a new document',
            icon: 'ri-upload-cloud-line',
            color: 'primary',
            link: '/documents/upload'
        },
        {
            title: 'View API Tokens',
            description: 'Manage your API access tokens',
            icon: 'ri-key-line',
            color: 'info',
            link: '/api-token'
        },
        {
            title: 'Team Management',
            description: 'Add or manage team members',
            icon: 'ri-team-line',
            color: 'warning',
            link: '/team'
        },
        {
            title: 'Usage Reports',
            description: 'View detailed usage analytics',
            icon: 'ri-bar-chart-line',
            color: 'success',
            link: '/reports'
        },
        {
            title: 'Billing & Plans',
            description: 'Manage subscription and billing',
            icon: 'ri-bank-card-line',
            color: 'secondary',
            link: '/billing'
        }
    ];

    return (
        <Card className="card-animate">
            <CardHeader>
                <h4 className="card-title mb-0">Quick Actions</h4>
            </CardHeader>
            <CardBody>
                <div className="d-grid gap-2">
                    {quickActions.map((action, index) => (
                        <Link 
                            key={index} 
                            to={action.link} 
                            className="text-decoration-none"
                        >
                            <div className="d-flex align-items-center p-3 border rounded hover-shadow-sm">
                                <div className="flex-shrink-0">
                                    <div className={`avatar-sm rounded bg-${action.color}-subtle`}>
                                        <div className={`avatar-title bg-${action.color}-subtle text-${action.color} fs-18 rounded`}>
                                            <i className={action.icon}></i>
                                        </div>
                                    </div>
                                </div>
                                <div className="flex-grow-1 ms-3">
                                    <h6 className="mb-1 text-dark">{action.title}</h6>
                                    <p className="text-muted mb-0 small">{action.description}</p>
                                </div>
                                <div className="flex-shrink-0">
                                    <i className="ri-arrow-right-s-line text-muted"></i>
                                </div>
                            </div>
                        </Link>
                    ))}
                </div>
                
                <div className="mt-4">
                    <div className="alert alert-soft-info" role="alert">
                        <div className="d-flex">
                            <div className="flex-shrink-0">
                                <i className="ri-information-line"></i>
                            </div>
                            <div className="flex-grow-1 ms-2">
                                <strong>Need Help?</strong> Check out our <Link to="/docs">documentation</Link> or <Link to="/support">contact support</Link>.
                            </div>
                        </div>
                    </div>
                </div>
            </CardBody>
        </Card>
    );
};

export default QuickActions;